import React, { useEffect, useRef } from "react";

// SASS
import "./Part7.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import virusDnaImg from "../../assets/img/virus-dna-highlight-white.svg";
// import germ1Img from "../../assets/img/germ-3-yellow.svg";
// import germ2Img from "../../assets/img/germ-2-yellow.svg";
import germ3Img from "../../assets/img/germ-1-yellow.svg";
import girlImg from "../../assets/img/girl-running.png";
import grandmaImg from "../../assets/img/grandma-sitting.png";

// FUNCTION EXPORT
export default function Part7({ step, setCurrentVirusPart }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    { stepNumber: "1", height: null, description: "fade in left text" },
    {
      stepNumber: "2",
      height: null,
      description: "fade in grandma, fade in right text",
    },
    { stepNumber: "3", height: null, description: "spacer" },
    {
      stepNumber: "4",
      height: null,
      description: "change bg color to #A74920, change virus part to envelope",
    },
  ];

  // REFS
  const leftTextEl = useRef(null);
  const rightTextEl = useRef(null);
  const grandmaEl = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeInOnEnter(leftTextEl.current, direction);
            break;
          }
          case "2": {
            animate.fadeInOnEnter(rightTextEl.current, direction);
            animate.fadeInOnEnter(grandmaEl.current, direction);
            break;
          }
          case "4": {
            if (direction === "down") setCurrentVirusPart("envelope");
            animate.changeBodyBgColorDown("#A74920", direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeOutOnExit(leftTextEl.current, direction);
            break;
          }
          case "2": {
            animate.fadeOutOnExit(rightTextEl.current, direction);
            animate.fadeOutOnExit(grandmaEl.current, direction);
            break;
          }
          case "4": {
            if (direction === "up") setCurrentVirusPart("proteins");
            animate.changeBodyBgColorUp("#008996", direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part7">
          {/* <div className="top-container">
            <div className="virus virus-1">
              <img src={virusDnaImg} alt="" className="img-fluid" />
            </div>
            <div className="virus virus-2">
              <img src={virusDnaImg} alt="" className="img-fluid" />
            </div>
            <div className="germ germ-1">
              <img src={germ1Img} alt="" className="img-fluid" />
            </div>
            <div className="germ germ-2">
              <img src={germ2Img} alt="" className="img-fluid" />
            </div>
          </div> */}
          <div className="middle-text">
            These special proteins allow the virus to:
            <div className="virus spin">
              <img src={virusDnaImg} alt="" className="img-fluid" />
            </div>
            <div className="germ rotate">
              <img src={germ3Img} alt="" className="img-fluid" />
            </div>
          </div>
          <div className="bottom-container">
            <div className="girl">
              <img src={girlImg} alt="" className="img-fluid" />
            </div>
            <div className="grandma" ref={grandmaEl}>
              <img src={grandmaImg} alt="" className="img-fluid" />
            </div>
            <div className="text text-left" ref={leftTextEl}>
              travel around the body
            </div>
            <div className="text text-right" ref={rightTextEl}>
              travel from one person to another
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
